import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceptionApiAdapter } from '../adapters/ReceptionApiAdapter';
import { UpdateReceptionRequest } from '../models/Reception';
import { ReceptionService } from '../services/ReceptionService';

interface UpdateReceptionParams {
  id: number;
  data: UpdateReceptionRequest;
  currentStatus: string;
}

/**
 * Hook para actualizar una recepción existente
 */
export const useUpdateReception = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ReceptionApiAdapter(httpClient);
  const receptionService = new ReceptionService(apiAdapter);

  return useMutation({
    mutationFn: ({ id, data, currentStatus }: UpdateReceptionParams) =>
      receptionService.updateReception(id, data, currentStatus),
    onSuccess: (_, variables) => {
      // Invalidar queries de lista y detalle
      queryClient.invalidateQueries({ queryKey: ['receptions'] });
      queryClient.invalidateQueries({ queryKey: ['receptions-simple'] });
      queryClient.invalidateQueries({ queryKey: ['reception', variables.id] });
    },
  });
};

